export const formatText = (text: any): any => {
    if (!text) return text;

    let formatted = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    formatted = formatted.replace(/\*(.*?)\*/g, '<em>$1</em>');
    formatted = formatted.replace(/`(.*?)`/g, '<code style="background-color: #f1f5f9; padding: 2px 4px; border-radius: 3px; font-family: monospace;">$1</code>');

    // Handle bullet points (existing logic)
    formatted = formatted.replace(/^[\\-\\*]\s+(.+)$/gm, '• $1');

    // Enhanced formatting for price recommendations
    // Highlight price values (¥XXX format)
    formatted = formatted.replace(/¥(\d+)/g, '<span style="font-weight: 600; color: #059669;">¥$1</span>');

    // Highlight recommended items with arrow
    formatted = formatted.replace(/←\s*(RECOMMENDED)/gi, '<span style="color: #dc2626; font-weight: 700;">← $1</span>');

    // Format percentage increases
    formatted = formatted.replace(/\((\d+%)\)/g, '<span style="color: #059669; font-weight: 600;">($1)</span>');

    // Format arrows for directional changes
    formatted = formatted.replace(/(\d+)\s*→\s*(\d+)/g, '$1 <span style="color: #6b7280;">→</span> <strong>$2</strong>');

    // Format section headers (lines ending with colon)
    formatted = formatted.replace(/^([^:\n]+:)$/gm, '<strong style="color: #374151;">$1</strong>');

    // Convert literal \n strings to actual line breaks
    formatted = formatted.replace(/\\n/g, '<br>');

    // Convert newlines to breaks
    formatted = formatted.replace(/\n/g, '<br>');

    return formatted;
};
